export const CREATE_INVOICE = 'CREATE_INVOICE';
export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCH_INVOICE = 'FETCH_INVOICE';
export const FETCH_INVOICE_UID = 'FETCH_INVOICE_UID';
export const EDIT_INVOICE = 'EDIT_INVOICE';
export const DELETE_INVOICE = 'DELETE_INVOICE';
